import { render, staticRenderFns } from "./ServiceLightPersonInfo.vue?vue&type=template&id=6dbd23f6"
import script from "./ServiceLightPersonInfo.vue?vue&type=script&scoped=true&lang=js"
export * from "./ServiceLightPersonInfo.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./ServiceLightPersonInfo.vue?vue&type=style&index=0&id=6dbd23f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports